import type { ChangeEvent } from 'react';

export const zipCodeSetter = <T>(
    event: ChangeEvent<Element>,
    field: T,
    callback: (field: T, value: string) => void
) => {
    const { value } = event.target as HTMLInputElement;

    // Check if first character is a letter (indicating a Canadian postal code)
    const isCanadaZip = /^[A-Za-z]$/.test(value.charAt(0));

    if (!isCanadaZip) {
        callback(field, value);
        return;
    }

    const formattedZipCode = formatCanadaZipCode(value);

    callback(field, formattedZipCode);
};

export const formatCanadaZipCode = (value: string) => {
    const upperValue = value.toUpperCase();

    let result;

    if (upperValue.charAt(3) === ' ') {
        result = upperValue.replace(/[^A-Z0-9 ]/g, '');
    } else {
        const cleaned = upperValue.replace(/[^A-Z0-9]/g, '');
        result = cleaned.length > 3 ? `${cleaned.slice(0, 3)} ${cleaned.slice(3)}` : cleaned;
    }

    return result.slice(0, 7);
};

export const getFormattedZipCode = (zipCode: string): string => {
    // Trim whitespace to handle leading/trailing spaces
    const trimmedZipCode = zipCode?.trim() || '';

    if (!trimmedZipCode) {
        return '';
    }

    // Check if first character is a letter (indicating a Canadian postal code)
    const isCanadaAddressPostal = /^[A-Za-z]$/.test(trimmedZipCode.charAt(0));

    // format Canada zip code
    if (isCanadaAddressPostal) {
        return formatCanadaZipCode(trimmedZipCode);
    }

    // for US zip code, remove spaces and take only first 5 characters before '-'
    const formattedUSZipCode = trimmedZipCode.replace(/\s/g, '').split('-')[0].slice(0, 5);

    return formattedUSZipCode;
};
